import { MapUtils } from '../../../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../../dto/data-model.js';

export class TargetAudience extends DataModel {
  static readonly TYPE_ID: string = 'c24f6f4f768a4de9932b1596da363271';

  private constructor(
    public readonly email: string,
  ) {
    super();
  }

  get $typeId(): string {
    return TargetAudience.TYPE_ID;
  }

  static create(args: {
    email: string,
  }): TargetAudience {
    return new TargetAudience(
        args.email,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): TargetAudience {
    return TargetAudience.create({
      email: MapUtils.getString(map, 'email'),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'email': this.email,
    };
  }

  clone(): this {
    return this.copyWith();
  }

  copyWith({
    email = this.email,
  }: {
    email?: string,
  } = {}): this {
    return TargetAudience.create({
      email,
    }) as this;
  }

  isSame(other: TargetAudience): boolean {
    if(other === this) {
      return true;
    }

    return other.email === this.email;
  }
}

export class TargetAudienceBuilder extends DataModelBuilder<TargetAudience> {
  build(context: SerializationContext, map: SerializedData): TargetAudience {
    return TargetAudience.fromMap(context, map);
  }
}
